import BlockUnblockDetails from './BlockUnblockDetails';

export default BlockUnblockDetails;
